import { APIENDPOINTS } from "../../constants/apiEndPoint";
import { baseApi } from "./baseQuery";

// Access for Department and Employee and Issues module api's

const accessPageApi = baseApi.injectEndpoints({
    endpoints: (build) => ({

        // Department api
        dashboardAdmin: build.query({
            query: () => ({
                url: APIENDPOINTS.DASHBOARD_ADMIN,
            }),
            providesTags: ["dashboard"]
        }),
        //Notification List API
        notificationList: build.query({
            query: () => ({
                url: APIENDPOINTS.NOTIFICATION_LIST,
            }),
            providesTags: ["notification"]
        }),
        notificationStatus: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.NOTIFICATION_STATUS + `?id=${values}`,
            }),
            invalidatesTags: ["notification"]
        }),
        //Profile details API
        profileDetails: build.query({
            query: () => ({
                url: APIENDPOINTS.PROFILE_DETAILS,
            }),
            providesTags: ["profilePage"]
        }),
        profileUpdate: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.PROFILE_DETAILS,
                method: "PUT",
                body: values
            }),
            invalidatesTags: ["profilePage"]
        }),
        //change password
        changePassword: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.CHANGE_PASSWORD,
                method: "PUT",
                body: values
            }),
            invalidatesTags: ["profilePage"]
        }),



        // Department api
        // departmentList: build.query({
        //     query: () => ({
        //         url: APIENDPOINTS.DEAPRTMENT_LIST,
        //     }),
        //     providesTags: ["manageDepartment"]
        // }),
        departmentList: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.DEAPRTMENT_LIST,
                method: "POST",
                body: values
            }),
            invalidatesTags: ["manageDepartment"]
        }),

        departmentGetOne: build.query({
            query: (values) => ({
                url: APIENDPOINTS.DEAPRTMENT_CRUD + `?id=${values}`,
            }),
            providesTags: ["manageDepartment"]
        }),

        departmentCreate: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.DEAPRTMENT_CRUD,
                method: "POST",
                body: values
            }),
            invalidatesTags: ["manageDepartment"]
        }),

        departmentUpdate: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.DEAPRTMENT_CRUD,
                method: "PUT",
                body: values
            }),
            invalidatesTags: ["manageDepartment"]
        }),

        departmentDelete: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.DEAPRTMENT_CRUD + `?id=${values}`,
                method: "DELETE",
            }),
            invalidatesTags: ["manageDepartment"]
        }),

        departmentDropdownList: build.query({
            query: () => ({
                url: APIENDPOINTS.DEAPRTMENT_DROPDOWN_LIST,
            }),
            providesTags: ["manageEmployee"]
        }),

        // Employee api

        employeeList: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.EMPLOYEE_LIST,
                method: "POST",
                body: values
            }),
            invalidatesTags: ["manageEmployee"]
        }),

        guestEmployeeList: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.GUEST_EMPLOYEE_LIST,
                method: "POST",
                body: values
            }),
            invalidatesTags: ["manageEmployee"]
        }),

        employeeGetOne: build.query({
            query: (values) => ({
                url: APIENDPOINTS.EMPLOYEE_CRUD + `?id=${values}`,
            }),
            providesTags: ["manageEmployee"]
        }),

        employeeCreate: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.EMPLOYEE_CRUD,
                method: "POST",
                body: values
            }),
            invalidatesTags: ["manageEmployee"]
        }),

        employeeUpdate: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.EMPLOYEE_CRUD,
                method: "PUT",
                body: values
            }),
            invalidatesTags: ["manageEmployee"]
        }),

        employeeDelete: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.EMPLOYEE_CRUD + `?id=${values}`,
                method: "DELETE",
            }),
            invalidatesTags: ["manageEmployee"]
        }),

        // Issues api

        issuesList: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.ISSUES_LIST,
                method: "POST",
                body: values
            }),
            invalidatesTags: ["manageIssue"]
        }),
        issuesListDownload: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.ISSUES_LIST_DOWNLOAD,
                method: "POST",
                body: values
            }),
            invalidatesTags: ["manageIssue"]
        }),

        // issuesList: build.query({
        //     query: () => ({
        //         url: APIENDPOINTS.ISSUES_LIST,
        //     }),
        //     providesTags: ["manageIssue"]
        // }),

        issuesListGetOne: build.query({
            query: (values) => ({
                url: APIENDPOINTS.ISSUES_CRUD + `?id=${values}`,
            }),
            providesTags: ["manageIssue"]
        }),

        issuesTracker: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.ISSUES_TRACKER,
                method: "PUT",
                body: values
            }),
            invalidatesTags: ["manageIssue"]
        }),

        issuesFeedback: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.ISSUES_FEEDBACK,
                method: "PUT",
                body: values
            }),
            invalidatesTags: ["manageIssue"]
        }),

        // delete 
        deleteIssueById: build.mutation({
            query: (id) => ({
                url: APIENDPOINTS.ISSUES_TRACKER + `?id=${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["manageIssue"]
        }),


        /* Admin Api */
        adminList: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.ADMIN_LIST,
                method: "POST",
                body: values
            }),
            invalidatesTags: ["manageAdmin"]
        }),

        departmentEmployeelist: build.query({
            query: () => ({
                url: APIENDPOINTS.ADD_ADMIN_DROPDOWN,
            }),
            providesTags: ["manageAdmin"]
        }),

        adminCreateApi: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.ADMIN_CREATE_API,
                method: "POST",
                body: values
            }),
            invalidatesTags: ["manageAdmin"]
        }),


    }),
    // @ts-ignore
    overrideExisting: module.hot?.status() === "apply",
});

export const {
    // Dashboard
    useDashboardAdminQuery,
    // Notification
    useNotificationListQuery,
    useNotificationStatusMutation,

    //profile
    useProfileDetailsQuery,
    useProfileUpdateMutation,
    useChangePasswordMutation,
    // Department
    useDepartmentListMutation,
    useDepartmentGetOneQuery,
    useDepartmentCreateMutation,
    useDepartmentUpdateMutation,
    useDepartmentDeleteMutation,
    useDepartmentDropdownListQuery,
    // Employee
    useEmployeeListMutation,
    useGuestEmployeeListMutation,
    useEmployeeGetOneQuery,
    useEmployeeCreateMutation,
    useEmployeeUpdateMutation,
    useEmployeeDeleteMutation,

    // Issues
    useIssuesListMutation,
    useIssuesListDownloadMutation,
    useIssuesListGetOneQuery,
    useIssuesTrackerMutation,
    useIssuesFeedbackMutation,
    useDeleteIssueByIdMutation,

    //Admin
    useAdminListMutation,
    useDepartmentEmployeelistQuery,
    useAdminCreateApiMutation,





} = accessPageApi;